import React from "react"
import GridContainer from "@/components/common/GridContainer"
import { useStructuredContext } from "@/components/common/StructuredText"
import DynamicMargin from "@/components/common/DynamicMargin"
import { getMarginsData } from "@/utils/utils"

export function getStructuredHeadingTypo(level) {
	return level === 2 ? "typo-borna-64" : "typo-borna-26"
}

const MARGIN_SIZES = {
	TOP: {
		MOBILE: 24,
		TABLET: 24,
		DESKTOP: 48,
	},
	BOTTOM: {
		MOBILE: 24,
		TABLET: 24,
		DESKTOP: 24,
	},
}

const Heading = ({ data, children }) => {
	const headingLevel = data.level
	const HeadingTag = `h${headingLevel}`
	const indent = useStructuredContext("indent")
	const width = useStructuredContext("width")
	// Add HTML anchors to heading levels for in-page navigation
	// const anchor = toPlainText(data)
	// 	.toLowerCase()
	// 	.replace(/ /g, "-")
	// 	.replace(/[^\w-]+/g, "")

	const finalIndent = headingLevel === 2 ? "indent-desktop-0" : `indent-desktop-${indent}`
	const columnsLayout = headingLevel === 2 ? "col-mobile-8 col-tablet-8 col-desktop-9" : `col-mobile-8 col-tablet-8 col-desktop-${width}`
	const typoClass = getStructuredHeadingTypo(headingLevel)

	const { marginTop, marginBottom } = getMarginsData(data)

	return (
		<DynamicMargin marginTop={marginTop} marginBottom={marginBottom} marginSizes={MARGIN_SIZES}>
			<GridContainer className={finalIndent}>
				<div className={columnsLayout}>
					<HeadingTag className={`typo-borna no-select ${typoClass}`}>{children}</HeadingTag>
				</div>
			</GridContainer>
		</DynamicMargin>
	)
}

export default Heading
